/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetWithdrawalSecretsQueryResponse, GetWithdrawalSecrets400, GetWithdrawalSecrets403 } from '../entities/GetWithdrawalSecrets'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetWithdrawalSecretsUrl() {
  return `/withdrawal-secrets` as const
}

/**
 * @description Получение списка api-ключей вывода средств для таксопарка
 * @summary Получение списка api-ключей вывода средств для таксопарка
 * {@link /withdrawal-secrets}
 */
export async function getWithdrawalSecrets(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetWithdrawalSecretsQueryResponse, ResponseErrorConfig<GetWithdrawalSecrets400 | GetWithdrawalSecrets403>, unknown>({
    method: 'GET',
    url: getGetWithdrawalSecretsUrl().toString(),
    ...requestConfig,
  })
  return res.data
}